import styled from '@emotion/styled'
import { Theme } from '@mui/material'

export const FooterContainer = styled.div`
	display: flex;
	gap: 0.75rem;
`

export const ContentContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.75rem;
`

export const TextFieldSx = (isReadOnly: boolean, _isDisabled?: boolean) => {
	return {
		'& .MuiInputBase-root': {
			fontSize: 14,
			// Remove default borders
			'&::before': {
				borderBottom: 'none',
			},
			// Override disabled state dotted border
			'&.Mui-disabled::before': {
				borderBottom: 'none !important',
				borderBottomStyle: 'none !important',
			},
			'&:hover:not(.Mui-disabled):before': {
				borderBottom: (theme: Theme) =>
					isReadOnly ? 'none' : `2px solid ${theme.palette.secondary.dark}`,
				transition: 'none',
			},
			'&::after': {
				borderBottom: (theme: Theme) =>
					isReadOnly ? 'none' : `2px solid ${theme.palette.primary.main}`,
			},
			// Remove any side borders
			borderLeft: 'none',
			borderRight: 'none',
			// Force black text for disabled state
			'&.Mui-disabled': {
				color: 'black',
			},
		},
		'& .MuiInputBase-input': {
			cursor: isReadOnly ? 'not-allowed' : 'text',
			padding: '6px 2px',
			marginRight: '5px',
			color: 'black !important',
			WebkitTextFillColor: 'black !important',
			backgroundColor: 'transparent',
		},
		// Ensure no side padding that might create visual borders
		'& .MuiInput-root': {
			paddingLeft: 0,
			paddingRight: 0,
		},
		// Fix any additional borders from the table cell
		border: 'none',
		outline: 'none',
	}
}
